import * as React from "react";
import { OrganizationKeyName } from "../../model/Organization";
/* import { RootState } from "../../store"; */
import { SecondaryButton } from "../../components/Buttons";
import { colors } from "../../components/colors";
import { useDeleteRestaurantImage } from "./service/venue-api";
import { ActionSpinner } from "../../components/ActionSpinner";
import { toastr } from "react-redux-toastr";
import { getErrorMessage } from "../../error-handler";

interface Props {
  organization: OrganizationKeyName;
  venueId: string | number | undefined;
  showDeleteButton: boolean;
  image: {
    url: string;
    backgroundColor?: string;
  };
}

const VenueUpsertFromImage: React.FC<Props> = ({
  organization,
  venueId,
  image,
  showDeleteButton,
}) => {
  const {
    mutateAsync: deleteRestaurantImage,
    isLoading,
  } = useDeleteRestaurantImage(venueId);

  const deleteImage = async (imageUrl: string) => {
    try {
      await deleteRestaurantImage({
        imageUrl: image.url,
        id: venueId,
        organizationKeyName: organization,
      });
      toastr.success("Success", "Image deleted successfully");
    } catch (error: unknown) {
      const message = getErrorMessage(error);
      toastr.error("Error", message);
    }
  };

  return (
    <React.Fragment key={image.url}>
      <div className="col-md-3">
        <div className="card">
          <a href={image.url}>
            <img src={image.url} alt={image.url} />
          </a>
          {showDeleteButton && (
            <div className="card-footer d-flex justify-content-end p-2">
              <div className="caption text-right w-100">
                <SecondaryButton
                  type="button"
                  hoverColor={colors.errorLight}
                  color={colors.errorDark}
                  disabled={isLoading}
                  backgroundColor="white"
                  onClick={async () => {
                    await deleteImage(image.url);
                  }}
                  className="w-100"
                >
                  {isLoading ? <ActionSpinner /> : "Delete"}
                </SecondaryButton>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default VenueUpsertFromImage;
